import { TMovementType, TMovementTypeGroup } from '@/entities/movement-type';

export const priorityMap: Partial<Record<TMovementType & TMovementTypeGroup, number>> = {
  [TMovementType.foot]: 0,
  [TMovementType.car]: 1,
  [TMovementType.bus]: 2,
  [TMovementTypeGroup.bicycleScooter]: 3,
  [TMovementTypeGroup.motorcycleQuadbike]: 4,
  [TMovementType.horseback]: 5,
  [TMovementTypeGroup.watership]: 6,
  [TMovementType.boat]: 7,
  [TMovementTypeGroup.boatKayakSup]: 8,
  [TMovementTypeGroup.yachtSpeedboat]: 9,
  [TMovementTypeGroup.balloonParaglider]: 10,
  [TMovementTypeGroup.airplaneHelicopter]: 11,
  [TMovementTypeGroup.roomMuseum]: 12,
  [TMovementType.other]: Infinity, // чтобы всегда был последний в списке

  // [TMovementType.bicycle]: 3,
  // [TMovementType.scooter]: 4,
  // [TMovementType.motorcycle]: 5,
  // [TMovementType.quadbike]: 6,
  // [TMovementType.kayak]: 10,
  // [TMovementType.sup]: 11,
  // [TMovementType.yacht]: 12,
  // [TMovementType.speedboat]: 13,
  // [TMovementType.jetski]: 14,
  // [TMovementType.motorship]: 15,
  // [TMovementType.balloon]: 16,
  // [TMovementType.paraglider]: 17,
  // [TMovementType.airplane]: 18,
  // [TMovementType.helicopter]: 19,
  // [TMovementType.museum]: 21,
};
